import { extractMenuItems as h } from "./lib/CfgApi/extractMenuItems.js";
const o = async (c, t) => fetch(`${c}/${t}`, {
  credentials: "include"
}).then((e) => e.json()).catch((e) => {
  console.error("failed to fetch " + e.message);
}), u = (c, t, e) => {
  const s = {
    version: e,
    menuItems: t
  };
  sessionStorage.setItem(c, JSON.stringify(s));
}, m = (c, t) => {
  const e = sessionStorage.getItem(c);
  if (e) {
    const s = JSON.parse(e);
    if (s.version === t)
      return s.menuItems;
  }
  return null;
}, i = async (c, t, e, s) => {
  const r = `${t}-cache`;
  let a = m(r, s);
  if (!a)
    try {
      const n = await o(c, t);
      a = h(n, e), u(r, a, s);
    } catch (n) {
      console.error("Failed to fetch menu data:", n.message), a = [];
    }
  return a;
}, g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cacheMenuItems: u,
  fetchMenuData: o,
  getCachedMenuItems: m,
  getMenu: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  i as a,
  g as b,
  u as c,
  o as f,
  m as g
};
//# sourceMappingURL=getMenu-5753da8b.mjs.map
